import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderServerComponent } from "@tanstack/react-start/rsc";
import PrivacyPolicyContent from "src/components/policies/PrivacyPolicyContent";
import { metadataHead } from "src/lib/Metadata";
import { withHydrationMarker } from "src/lib/ServerContent";
import { renderCachedServerComponent } from "src/server/FlightCache";

// A server component, like the Terms (src/routes/_policies/terms.tsx).
const getPrivacyPolicyContent = createServerFn({ method: "GET" }).handler(() =>
  renderCachedServerComponent("policy:privacy-policy", () =>
    renderServerComponent(withHydrationMarker(<PrivacyPolicyContent />)),
  ),
);

export const Route = createFileRoute("/_policies/privacy-policy")({
  loader: () => getPrivacyPolicyContent(),
  // The text only changes with a deploy.
  staleTime: Number.POSITIVE_INFINITY,
  head: () =>
    metadataHead({
      title: "Privacy policy",
      description:
        "Learn how CalmLens collects, uses, stores and protects personal information, and how to exercise your privacy rights.",
      alternates: { canonical: "/privacy-policy" },
    }),
  component: () => <>{Route.useLoaderData()}</>,
});
